import {decimalOrWhole} from '@deliveriesondemand/dod-utils';
import {formatMoney} from 'accounting';
import {Component} from 'react';
import injectSheet from 'react-jss';

import BypassAuthButton from '-/components/fields/BypassAuthButton';
import Button from '-/components/general/Button';
import greetingStyles from '-/styles/sections/greeting';
import NotMe from '-/components/general/NotMe';

class DefaultLanding extends Component {
    onStipsClick = e => {
        e.preventDefault();

        window.location.href = `${window.location.href}&stips=app&ffwd=1`;
    };

    render() {
        const {
            auth: {
                authInfo,
                authType,
                showBypassAuthButton
            } = {},
            classes = {},
            creditor: {
                shortName = ''
            } = {},
            currentStepLastSession,
            dealInfo: {
                lifeTimeSavings,
                newRate
            } = {},
            onNextClick,
            applicantName,
            status,
            stips: {
                app: {
                    requestStatus
                } = {}
            } = {}
        } = this.props;

        const isSubmitted = status === 'SUBMITTED';

        let stipsBtnText;
        let greeting = currentStepLastSession ? `Welcome Back, ${applicantName}` : `Congratulations, ${applicantName}`;
        let p2 = 'We only need you to verify a few pieces of information.';
        let buttonText = currentStepLastSession ? 'Let\'s finish where you left off!' : 'Get Started';
        let p1 = newRate ? <b>You locked down your {decimalOrWhole(newRate)}% rate!</b> : '';

        if (shortName === 'evolveBG') {
            p1 = <b>You locked down your rate!</b>;
        }

        let p3 = lifeTimeSavings ?
            <p className={classes.p}>
                You are one step closer to interest savings of about
                &nbsp;{formatMoney(lifeTimeSavings)}.
            </p> : '';

        if (lifeTimeSavings < 1000) {
            p3 = <p className={classes.p}>You are one step closer to great interest savings!</p>;
        }

        if (isSubmitted) {
            buttonText = 'Review your information';
            p1 = 'Application Submitted';
            p2 = 'Thanks for submitting your application with us!';
            p3 = '';

            stipsBtnText = requestStatus === 'REQUESTEDFIRSTTIME' ? 'Upload Documents' : 'Check Status / Upload Documents';
        }

        return (
            <section className={classes.root}>
                <h1>{greeting}</h1>
                <p className={classes.p}>{p1}</p>
                <p className={classes.p}>{p2}</p>
                {showBypassAuthButton &&
                    <BypassAuthButton
                        authType={authType}
                        authInfo={authInfo}
                        buttonText={buttonText} />
                }
                {!showBypassAuthButton &&
                    <Button
                        width={90}
                        tag="a"
                        href="#"
                        onClick={onNextClick}
                        title={buttonText}
                        role="button">
                        {buttonText}
                    </Button>
                }
                {isSubmitted &&
                    <Button
                        width={90}
                        tag="a"
                        href="#"
                        onClick={this.onStipsClick}
                        title={stipsBtnText}
                        role="button">
                        {stipsBtnText}
                    </Button>
                }
                <NotMe />
                {p3}
                {!isSubmitted && lifeTimeSavings > 0 && (
                    <p className={classes.p}>
                        <b>&quot;Not too bad for a few minutes work.&quot;</b>
                    </p>
                )}
            </section>
        );
    }
}

export default injectSheet(greetingStyles)(DefaultLanding);
